// extracted by mini-css-extract-plugin
export default {"container":"components-hotel-pricing-assistant-table-popovers-override-cell-popover-module__container"};